import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FILE_FORMAT_ACEPT, FILE_FORMAT_ACEPT_REGEXP } from 'src/app/app.constants';
import { IFileUpload } from 'src/app/core/models/file-upload.interface';
import { v4 as uuidv4 } from 'uuid';


@Component({
  selector: 'app-upload-files',
  templateUrl: './upload-files.component.html',
  styleUrls: ['./upload-files.component.scss']
})
export class UploadFilesComponent implements OnInit {

  @Output() fileList = new EventEmitter<IFileUpload[]>();
  @Input() labelFormatAceptString = 'Imágenes o PDF';
  @Input() formatAceptString = '';
  @Input() maxFiles = 1;
  @Input() maxMbFileUpload = 5;
  @Input() fileFormatAcept: string[] = FILE_FORMAT_ACEPT;


  public files: IFileUpload[] = [];

  public customId = '';
  public fileSelected: any;
  public fileFormatAceptStr = '';
  public multiple = false;

  constructor() {
    this.customId = uuidv4();    
  }

  @Input()
  set persistanFiles(val: IFileUpload[]) {
    if (val.length) {
      this.files = val;
    }
  }

  ngOnInit(): void {
    this.multiple = Number(this.maxFiles) > 1;
    this.fileFormatAceptStr = this.fileFormatAcept.join(',');
  }

  public handleFileInput(event: any): void {

    // Validar el maximo de archivos
    if (event?.target.files) {
      for (let i = 0; i < event?.target.files.length; i++) {
        if (this.files.length < this.maxFiles) {
          const file: File = event?.target.files.item(i);
          const uploadFile: IFileUpload = this.trasnformFile(file);
          this.files.push(uploadFile);
          this.validateAndUploadFile(uploadFile);
        }        
      }
      this.fileSelected = undefined;
      this.uploadFile();
    }
  }


  private trasnformFile(file: File): IFileUpload {
    let totalSize: number;
    // Seteo el tamaño en MB
    totalSize = Math.ceil((file.size / 1048576) * 10) / 10;

    return {
      nativeFile: file,
      totalSize,
      name: file.name,
    };
  }

  private validateAndUploadFile(uploadFile: IFileUpload): void {
    uploadFile.errorMsg = undefined;
    if (!this.validateFormatFileUpload(uploadFile)) {
      uploadFile.errorMsg = 'Formato de archivo no valido'
    } else if (!this.validateFileSize(uploadFile)) {
      uploadFile.errorMsg = `El tamaño maximo de archivo permitido es ${this.maxMbFileUpload}MB`;
    }
  }

  private validateFormatFileUpload(uploadFile: IFileUpload): boolean {
    return (
      this.fileFormatAcept.includes(uploadFile.nativeFile.type) ||
      (!uploadFile.nativeFile.type && FILE_FORMAT_ACEPT_REGEXP.test(uploadFile.nativeFile.name))
    );
  }

  private validateFileSize(uploadFile: IFileUpload): boolean {
    return uploadFile.totalSize <= this.maxMbFileUpload;
  }

  public deleteFile(index: number): void {
    this.files.splice(index, 1);
    this.uploadFile();
  }

  private async uploadFile() {    
    const filesToUpload = this.files.filter((o: IFileUpload) => !o.errorMsg);
    this.fileList.emit(filesToUpload);
  }

  

}
